export enum OrderSourceSystem {
  All = -1,
  ArcContracts = 0,
  Dynamics = 3
}
